







import Vue from "vue";
import { Tutor } from "../types";

export default Vue.extend({
  props: {
    tutor: {
      type: Object as () => Tutor,
      required: true
    }
  }
});
